<div class="input-group">
        <span class="input-group-text" *ngIf="fontawesomeLabelIcon">
            <i [ngClass]="fontawesomeLabelIcon"></i></span>


    <input (change)="observerKey($event)" type="search" class="form-control" (input)="filterItems()" [formControl]="control" />

    <button *ngIf="showButton" type="button" (click)="clickButtonAction()" class="btn btn-secondary">
        <i [ngClass]="fontawesomeButtonIcon"> </i>
    </button>
</div>
<div class="autocomplete" style="width: 100;">
    <ul class="list-group" *ngIf="filteredItems.length > 0">
        <li class="list-group-item" *ngFor="let item of filteredItems" (click)="onItemClick(item)">{{ item?.value }}
        </li>
    </ul>
</div>